<template>
  <nav>
    <v-app-bar app clipped>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="text-uppercase grey--text" style="width: 100%; height: 100%;">
        <div class="epiroc-container-logo"></div>
      </v-toolbar-title>
    </v-app-bar>

    <v-navigation-drawer app v-model="drawer" class="primary" src="bg-3.jpg" temporary>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title white--text" style="width: 100%;">
              <div class="epiroc-container-logo"></div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item v-for="link in viewableLinks" :key="link.text" router :to="link.route">
          <v-list-item-action>
            <v-icon class="white--text">{{ link.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="white--text">{{ link.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
        <v-list-item>
          <v-list-item-content>
            <v-switch :label="$t('common.darkTheme')" v-model="darkTheme"></v-switch>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import { mapState } from "vuex";
import { Roles } from "@/_helpers/Role";

export default {
  name: "NavBar",

  props: ["dark"],

  sync: true,

  data() {
    return {
      drawer: false,
      darkTheme: this.$vuetify.theme.dark
    };
  },
  computed: {
    ...mapState("users", ["currentUser", "status", "userCompany"]),

    viewableLinks() {
      var links = [];
      if (this.status.loggedIn) {
        var authLinks = this.authLinks.filter(l => {
          var role = this.currentUser.role;

          return l.role.includes(role);
        });

        links = links.concat(authLinks);
      } else {
        links = this.guestLinks;
      }

      return links;
    },

    guestLinks() {
      return [
        {
          icon: "home",
          text: this.$t("routes.home"),
          route: "/",
          role: [Roles.Guest]
        },
        {
          icon: "mdi-login",
          text: this.$t("routes.login"),
          route: "/login",
          role: [Roles.Guest]
        }
      ];
    },

    authLinks() {
      return [
        {
          icon: "dashboard",
          text: this.$t("routes.dashboard"),
          route: "/dashboard",
          role: [Roles.SuperAdmin, Roles.User, Roles.Admin, Roles.CompanyAdmin]
        },

        {
          icon: "logout",
          text: this.$t("routes.logout"),
          route: "/logout",
          role: [
            Roles.SuperAdmin,
            Roles.User,
            Roles.Admin,
            Roles.CompanyAdmin,
            Roles.Guest
          ]
        }
      ];
    }
  },
  watch: {
    darkTheme(v) {
      this.$vuetify.theme.dark = v;

      return this.$vuetify.theme.dark;
    }
  }
};
</script>

<style>
.epiroc-container-logo {
  background-image: url("/epiroc-logo.png");
  background-position: left;
  background-size: contain;
  max-width: 30vw;
  min-height: 50px;
}
</style>
